export default {
  label: 'Upload file',
  ignoredLines: 'Ignored lines',
  invalidLines: 'Invalid lines',
  totalCount: 'Total count',
  saveButton: 'Save',
  success: 'Success!',
};
